export const features = [
  {
    title: "Javascript Frameworks Master",
    description:
      "React.js, Vue.js, Next.js, Express.js, Nest.js, Electron.js, NWjs and Nuxt.js",
  },
  {
    title: "Html5 Game Developer",
    description: "Phaser3, construct3, and PIXI.js",
  },
  {
    title: "Blockchain Developer",
    description: "Ether.js, Web3.js, Solidity, Rust, Pack",
  },
  {
    title: "AI && Data Visulization Master",
    description: "Tensorflow, D3.js, OpenCV",
  },
  {
    title: "DataBase Master",
    description: "MongoDB, MySQL, PostgreSQL",
  },
  {
    title: "3D Projects Master",
    description: "Three.js and Unity",
  },
  {
    title: "Socket Programming Master",
    description: "Web RTC, Web Socket",
  },
];

export const products = [
  {
    title: "DEX Tools",
    url: "https://www.dextools.io/app/",
    img: "site23.png",
    description: "Angular + Web3",
  },
  {
    title: "Monetaria liquidity protocol",
    url: "https://monetaria-interface.vercel.app/",
    img: "site26.png",
    description: "Next.js + MUI + Web3",
  },
  {
    title: "Tree Defi",
    url: "https://treedefi.com/",
    img: "site24.png",
    description: "React + Web3 + MUI",
  },
  {
    title: "Leven ICO",
    url: "https://levenproject.org/",
    img: "site25.png",
    description: "Nextjs + Web3 + Styled Components",
  },
  {
    title: "PrimeAPE",
    url: "https://primeapeplanet.com/",
    img: "site13.png",
    description: "GSAP Project",
  },
  {
    title: "Monkeyleague (Solana)",
    url: "https://www.monkeyball.com/",
    img: "site8.png",
    description: "React.js + Moralis + Smart Contract",
  },
  {
    title: "Wizzair",
    url: "https://wizzair.com/#/",
    img: "site27.png",
    description: "Vue.js + Ethers.js",
  },
  {
    title: "Keap",
    url: "https://keap.com/",
    img: "site28.png",
    description: "Laravel + Vue.js + Ethers.js",
  },
  {
    title: "BSCPad",
    url: "https://bscpad.com/",
    img: "site12.png",
    description: "React.js + Moralis + Smart contract",
  },
  {
    title: "SomniumSpace",
    url: "https://somniumspace.com/",
    img: "site14.png",
    description: "React.js(Ant Design) + Unity",
  },
  {
    title: "AutoShark",
    url: "https://autoshark.finance/",
    img: "site16.png",
    description: "DEFI Project",
  },
  {
    title: "HoneySwap",
    url: "https://honeyswap.org/",
    img: "site17.png",
    description: "DEFI Project",
  },
  {
    title: "AlphaQuark",
    url: "https://lending.alphaquark.io/",
    img: "site18.png",
    description: "React.js + Moralis + Tailwind Css",
  },
  {
    title: "Kavlingezoo",
    url: "http://www.kavlingezoo.se/",
    img: "site19.png",
    description: "Laravel Project",
  },
  {
    title: "Lostcenturia",
    url: "https://lostcenturia.gg/en",
    img: "site20.png",
    description: "Laravel Project",
  },
  {
    title: "Varagon",
    url: "https://varagon.com/",
    img: "site21.png",
    description: "PIXI.js Project",
  },
  {
    title: "ServiceContract.com",
    url: "https://sc.aakba.com/",
    img: "site1.png",
    description: "React.js Project",
  },
  {
    title: "Fresha",
    url: "https://www.fresha.com/",
    img: "site2.png",
    description: "React.js Project",
  },
  {
    title: "BlablaCar",
    url: "https://www.blablacar.com.br/",
    img: "site3.png",
    description: "React.js Project",
  },
  {
    title: "BlueFox Studio",
    url: "https://bluefox.studio/",
    img: "site4.png",
    description: "Three.js Project",
  },
  {
    title: "Junni",
    url: "https://next.junni.co.jp/",
    img: "site5.png",
    description: "Three.js Project",
  },
  {
    title: "deliveroo",
    url: "http://www.deliveroo.com/",
    img: "site6.png",
    description: "Next.js + Node",
  },
  {
    title: "Anonydoxx Dapp",
    url: "https://anonydoxx.network",
    img: "site7.png",
    description: "React.js + Moralis",
  },

  {
    title: "HomeStyler",
    url: "https://www.homestyler.com/",
    img: "site9.png",
    description: "Nuxt.js + Node.js",
  },
  {
    title: "Sonder",
    url: "https://www.sonder.com/",
    img: "site10.png",
    description: "Node.js + Next.js + Amazon S3 + MUI",
  },
  {
    title: "Gobito",
    url: "https://newportal.akademi.ws/",
    img: "site11.png",
    description: "Node.js + Next.js + Amazon S3 + MUI",
  },
];

export const projects = [
  {
    title: "Project",
    items: ["/NFT9.png", "/NFT10.png", "/NFT11.png", "/NFT12.png"],
  },
  {
    title: "Project",
    items: ["/NFT13.png", "/NFT14.png", "/NFT15.png", "/NFT16.png"],
  },
];
